import { Td, Tfoot, Tr } from '@ff-it/ui';
import { useTable } from 'components/ControlledTable';
import { TitleContainer } from 'components/TitleContainer';
import { ReactElement } from 'react';
import { sepFormat } from 'utilities';

export function ListTotalsFooter(): ReactElement | null {
  const { data, columns } = useTable();
  if (!data?.totals) {
    return null;
  }
  const { sub_total, total }: { sub_total: string; total: string } = data.totals;

  const count = columns.length;
  const totalIndex = columns.findIndex((c) => c.key === 'total');

  // total column hidden — fall back to a single full-width cell
  if (totalIndex < 0) {
    return (
      <Tfoot>
        <Tr>
          <Td colSpan={count} textAlign="right" fontSize="xs">
            Total (all pages) <strong>{sepFormat(total)}</strong>{' '}
            <span className="text-muted">/ {sepFormat(sub_total)}</span>
          </Td>
        </Tr>
      </Tfoot>
    );
  }

  const trailing = count - totalIndex - 1;

  return (
    <Tfoot>
      <Tr>
        {totalIndex > 0 && (
          <Td colSpan={totalIndex} textAlign="right" fontSize="xs">
            Total (all pages)
          </Td>
        )}
        <Td textAlign="right" fontWeight="bold" className="py-0">
          <TitleContainer title={sepFormat(total)} subtitle={sepFormat(sub_total)} />
        </Td>
        {trailing > 0 && <Td colSpan={trailing} />}
      </Tr>
    </Tfoot>
  );
}
